<template>
	<section ref="el" data-component="tagline">
		<div class="g-row">
			<div class="xxl-16 wrapper">
				<h2 class="-title-2 title">
					<SanityContent :value="title" :components="components" />
				</h2>

				<p class="-headline-5 description">{{ description }}</p>

				<div class="icon-wrapper">
					<Icon slug="ic-arrow-right" class="icon" size="md" />
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
import { gsap } from 'gsap'
import { h } from 'vue'

import { Icon } from '~/components/core'

const props = defineProps({
	title: { type: [Array, Boolean], default: undefined },
	description: { type: String, default: undefined },
})

const components = {
	block: {
		normal: (_, { slots }) => h('span', { class: 'title-line' }, slots.default?.()),
	},
}

const el = ref(null)
const context = inject('pageContext')

const setup = () => {}
const init = () => {}
const kill = () => {}

onBeforeUnmount(() => {})
onMounted(() => {
	context.$page.loader.loaded.then(() => setup())
	context.$page.loader.transitionReady.then(() => init())
})
</script>

<style lang="scss" scoped>
[data-component='tagline'] {
	position: relative;
	width: 100%;
	overflow: hidden;

	// margin-top: rs(220, 100);
	margin-bottom: rs(68, 68);

	.g-row {
		justify-content: center;
		text-align: center;
	}

	.title {
		white-space: pre-line;
	}

	.title :deep(.title-line) {
		display: block;
		font-family: inherit;
		font-size: inherit;
		font-style: inherit;
		font-weight: inherit;
		line-height: inherit;
		letter-spacing: inherit;
		font-variation-settings: inherit;

		color: var(--color-neutral-tints-900);
	}

	.title :deep(strong) {
		color: var(--color-river-blue-500);
		font-family: inherit;
		font-size: inherit;
		font-style: inherit;
		font-weight: inherit;
		line-height: inherit;
		letter-spacing: inherit;
		font-variation-settings: inherit;
	}

	.description {
		margin-top: rs(14, 14);

		color: var(--color-neutral-tints-400);
	}
	.icon-wrapper {
		--icon-color: #{var(--color-river-blue-500)};

		display: flex;
		justify-content: center;
		align-items: center;

		width: rs(48, 48);
		height: rs(48, 48);

		border: 1px solid var(--color-river-blue-500);
		border-radius: 100px;

		margin: 0 auto;

		margin-top: rs(25, 25);

		:deep(svg) {
			transform: rotate(90deg);
		}
	}
}
</style>
